import React, {useState} from "react";
import {Layout, message, Pagination, Space, Table} from "antd";
import {columns} from '../CardRegistryData'
import {useTranslation} from "react-i18next";

/* Paging is owned by the parent: it is the side that queries the server, so
   keeping a second copy of the page number here only ever showed page 1. */
const RegistryTable = ({ data, loading, tableHeader, currentPage, pageSize, totalRows, onPageChange }) => {

    const { t } = useTranslation()

    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const [messageApi, contextHolder] = message.useMessage();

    const onSelect = (record, rowIndex) => {
        setSelectedRowKeys([record.id]);
        setSelectedRow(record);
    };

    const onRow = (record, rowIndex) => {
        return {
            onClick: () =>{ onSelect(record, rowIndex) }
        }
    };

    return (

        <Layout style={{height:"100%", overflow:"hidden"}}>
            {contextHolder}

            <div style={{position: 'relative', height: '100%'}}>

                <Space direction="horizontal" style={{width: '100%', justifyContent: 'right', margin: '16px 0'}}>
                    <Pagination
                        current={currentPage}
                        pageSize={pageSize}
                        total={totalRows}
                        onChange={onPageChange}
                        showSizeChanger={true}
                        size='small'
                        hideOnSinglePage={false}
                        showTotal={(total, range) => (
                            <span>
                                <strong>{total}</strong> катордан {range[0]}-{range[1]} гача
                            </span>
                        )}
                    />
                </Space>
                <Table
                    rowKey={(record) => record.id}
                    columns={columns(t)}
                    dataSource={data}
                    loading={loading}
                    title={tableHeader}
                    /* The surrounding Layout is height:100% with overflow
                       hidden, so rows past the fold are clipped unless the
                       table body scrolls on its own. What has to fit above it:
                       the 64px navigation bar, the pagination row (16+16 margin
                       + control), the title row with the button, the table head
                       at default row height, and the shell's 24px bottom
                       padding. BankCardsTab subtracts less because its rows are
                       size='small'. */
                    scroll={{x: 300, y: 'calc(100vh - 280px)'}}
                    /* The rows are one server page already; the Table's own
                       pagination would slice that page a second time. */
                    pagination={false}
                />
            </div>
        </Layout>
    );
};

export default RegistryTable;